import { Link, useParams } from "react-router-dom"
import { BACKEND } from "../config/configEnvs"
import { toast } from "react-toastify"
import { useEffect, useRef, useState } from "react"
import axios from "axios"
import { FaCalendar, FaCheckCircle, FaChevronRight, FaInfoCircle, FaLink, FaRegClock, FaSpinner, FaTrash, FaTypo3, FaUser } from "react-icons/fa"
import { Button, IconButton } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import getData from "../utils/getData/getData"
import ItemRowEvent from "../components/TrackeoLeads/ItemRowEvent"
import { FaRegNoteSticky } from "react-icons/fa6"
import Modal from "../components/ui/Modal"
import VerifyQuoteExists from "../utils/verifyData/VerifyQuoteExists"
import { MdDescription } from "react-icons/md"

import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";
import listPlugin from "@fullcalendar/list";
import Tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import HandleUpdateTextSelf from "../utils/HandleUpdateTextSelf"
import HandleUpdateSelectSelf from "../utils/HandleUpdateSelectSelf"
import CopyToClipBoard from "../utils/CopyToClipBoard"
import { FormatTimeStamp } from "../utils/FormatDate"
import { SendSharp } from "@mui/icons-material"
import { useSelector } from "react-redux"
import HandleUpdateDNI from "../utils/HandleValidateDNI"
import HandleUpdateRUC from "../utils/HandleValidateRUC"
import GetCountries from "../utils/getData/GetCountries"


const EventosLeads = () => {

  const user = useSelector(state => state.auth.user)

  const [rangeDates, setRangeDates] = useState({ start: null, end: null });

  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 900px)");
    setIsMobile(mediaQuery.matches);
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const { leadId } = useParams()

  const [viewMode, setViewMode] = useState("Tabla") // Calendario

  const [loadingStatus, setLoadingStatus] = useState(false) // Estado de carga

  const [openDetails, setOpenDetails] = useState(false) // Display de detalles del lead
  const [openQuotes, setOpenQuotes] = useState(false) // Display de cotizaciones del lead
  const [openNotes, setOpenNotes] = useState(false) // Display de notas del lead

  const [quotes, setQuotes] = useState([]) // Cotizaciones del cliente

  const [workers, setWorkers] = useState([]) // Trabajadores
  const [services, setServices] = useState([]) // Servicios

  // Notas general
  const [notes, setNotes] = useState([]) // Notas
  const [notesLoading, setNotesLoading] = useState(false)
  const [postNoteLoader, setPostNoteLoader] = useState(false) // Estado de carga notas
  const [newNote, setNewNote] = useState("") // Contenido nueva nota
  const [notesWidth, setNotesWidth] = useState("50px") // Ancho notas

  const [lead, setLead] = useState({}) // Lead seleccionado
  const [leadEvents, setLeadEvents] = useState([]) // Eventos del lead
  
  const [totalDocs, setTotalDocs] = useState([]) // Documentos totales
  const [totalPages, setTotalPages] = useState([]) // Páginas totales

  const [seller, setSeller] = useState("") // Filtro de vendedor
  const [eventType, setEventType] = useState("") // Filtro de tipo de evento
  const [eventSubType, setEventSubType] = useState("") // Filtro de subtipo de evento
  const [serviceInterest, setServiceInterest] = useState("") // Filtro de servicio de interés

  const [newEventModal, setNewEventModal] = useState(false) // Estado del modal
  const [countryNames, setCountryNames] = useState([]) // Países

  const [newEventForm, setNewEventForm] = useState({ // Formulario del nuevo evento
    title: "",
    description: "",
    lead: lead.id,
    createdAt: new Date().toISOString(),
    seller: "",
    eventType: "",
    eventSubType: "",
    rescheduledDate: "",
    eventLink: "",
    quote: "",
    budget: "",
    scheduledDate: "",
    dni: "",
    ruc: "",
  })

  // Notas
  const panelRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setOpenNotes(false);
      }
    };

    if (openNotes) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openNotes, setOpenNotes]);

  const getNotes = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/kommoMiddleware/getNotes?leadId=${lead.leadId}`)
      setNotes(response.data.notes.reverse())

    } catch (e) {
      if (e.response.status === 404) {
        return false
      }
      toast.error("Error al obtener las notas de Kommo: " + e)
    }
  }

  const postNotes = async () => {
    try {

      if (!newNote) {
        toast.warning("No puedes crear una nota vacía")
        return
      }

      if (!lead.leadId) {
        toast.error("No existe el ID del lead en la BD, actualiza cualquier campo en Kommo ;)")
        return
      }

      setPostNoteLoader(true)

      await axios.post(`${BACKEND}/api/kommoMiddleware/postNotes?leadId=${lead.leadId}`, {
        note: newNote
      })

      toast.success("Nota creada con éxito")
      setNewNote("")
      getNotes()
    } catch (e) {
      toast.error("Error al crear la nota: " + e)
    } finally {
      setPostNoteLoader(false)
    }
  }

  useEffect(() => {
    if (lead && lead.leadId) {
      getNotes()
    }
  }, [lead])
  // Fin Notas

  const resetEventForm = () => {
    setNewEventForm({
      title: "",
      description: "",
      lead: lead.id,
      seller: "",
      title: "",
      title: "",
      title: "",
      title: "",
      title: "",
      title: "",
    })
  }

  const getLeadData = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/registroLeads/${leadId}`)
      setLead(response.data)
    } catch (e) {
      toast.error("Error obteniendo la info del lead: " + e)
    }
  }

  const handleSubmitNewEvent = async (e) => {
    e.preventDefault();
  
    try {
      if (newEventForm.quote) {
        const quoteExists = await VerifyQuoteExists(newEventForm.quote);
        if (!quoteExists) {
          return toast.warning("La cotización indexada no existe");
        }
      }
  
      const { data: lastEvent } = await axios.get(
        `${BACKEND}/api/eventosLeads?where[lead][equals]=${leadId}&where[isLast][equals]=true&limit=1`
      );
  
      if (lastEvent.docs.length > 0) {
        await axios.patch(`${BACKEND}/api/eventosLeads/${lastEvent.docs[0].id}`, {
          isLast: false,
        });
      }

      const { quote, title, description, lead, ...rest } = newEventForm;
      const eventData = {
        title: title || "Sin título",
        description: description || "",
        lead: lead?.id || leadId,
        createdAt: new Date().toISOString(),
        leadStatus: lead?.status || "Lead",
        quote,
        isLast: true, 
        ...Object.fromEntries(Object.entries(rest).map(([key, val]) => [key, val || ""])),
      };
  
      await axios.post(`${BACKEND}/api/eventosLeads`, eventData);
  
      // Refrescar la tabla
      getData({
        setData: setLeadEvents,
        setTotalDocs,
        setTotalPages,
        route: "eventosLeads",
        limit: 0,
        params: `&where[lead][equals]=${leadId}`,
      });
  
      setNewEventModal(false);
      resetEventForm();
      toast.success("Evento creado correctamente");
    } catch (error) {
      toast.error("Error al crear el evento");
    }
  };

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`)
      const sellers = response.data.docs.filter((w) => w.area === "Comercial" || w.area === "Administracion" || w.puesto === "JEFE DE MARKETING")
      setWorkers(sellers)
    } catch (e) {
      console.log(e)
    }
  }

  const getUserQuotes = async () => {
    try {
      const response1 = await axios.get(`${BACKEND}/api/cotizaciones?where[lead][equals]=${leadId}`)
      const response2 = await axios.get(`${BACKEND}/api/cotizaciones?where[cliente.leadUser][equals]=${leadId}`)

      setQuotes([...response1.data.docs, ...response2.data.docs])
    } catch (e) {
      toast.error("Error al intentar obtener las cotizaciones: " + e)
    }
  }
  
  useEffect(() => {

    GetCountries({setter: setCountryNames})

    getLeadData()
    getWorkers()
    getUserQuotes()

    getData({
      setData: setLeadEvents, 
      setTotalDocs: setTotalDocs, 
      setTotalPages: setTotalPages, 
      route: "eventosLeads", 
      limit: 0, 
      params:`&where[lead][equals]=${leadId}`
    })

    getData({
      setData: setServices,
      route: "servicios",
      limit: 0,
    })

  }, [])

  useEffect(() => {

    let params = `&where[lead][equals]=${leadId}`

    if (seller) {
      params += `&where[seller][equals]=${seller}`
    }

    if (eventType) {
      params += `&where[eventType][equals]=${eventType}`
    }

    if (eventSubType) {
      params += `&where[eventSubType][equals]=${eventSubType}`
    }

    if (serviceInterest) {
      params += `&where[serviceInterest][equals]=${serviceInterest}`
    }

    getData({
      setData: setLeadEvents, 
      setTotalDocs: setTotalDocs, 
      setTotalPages: setTotalPages, 
      route: "eventosLeads", 
      limit: 0, 
      params: params
    })

  }, [seller, eventType, eventSubType, serviceInterest])

  const leadEventsForTable = leadEvents.map((event, index, array) => {
    const isFirst = event.eventType === "Entrada al sistema";
    const isLast = index === 0;

    // Definir colores según el tipo de evento
    let color = "white"; // Rojo por defecto
    let icon = "📌"; // Icono por defecto
    
    switch (event.eventType) {
      case "Entrada al sistema":
        color = "#7fdb1f"
        icon = "💻"; // Computadora para representar sistema
        break;
      case "Llamada":
        color = "#d3ccf1"
        icon = "📞"; // Teléfono
        break;
      case "Google Meet":
        color = "#73a6e4"
        icon = "📹"; // Cámara de video
        break;
      case "Cambio estado cotización":
        color = "#f0c83c"
        icon = "📝"; // Documento
        break;
    }

    return {
      id: event.id,
      title: `${icon} ${event.eventType} ${event.eventSubType ? `- ${event.eventSubType}` : ""}`, // Agrega el icono al título
      leadName: event.lead?.leadName,
      start: event.createdAt,
      allDay: true,
      description: `${event.description} ${event.lead?.phone ? `- ${event.lead?.phone}` : ""}`,
      eventType: event.eventType || "Otro",
      isFirst,
      isLast,
      color,
      extendedProps: {
        leadName: event.lead?.leadName || "Desconocido",
        description: event.description || "Sin descripción",
        phone: event.lead?.phone || "Sin teléfono",
      }
    };
  });

  const formatDateTimeForInputWithoutRound = (date) => {
    if (!date) return ''; // Verificar si la fecha está vacía
    const d = new Date(date); // Crear un objeto Date
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Agregar ceros si es necesario
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}`; // Formato para el input datetime-local
  };

  const stages = [
    { name: "Leads entrantes", value: "79717403" },
    { name: "Web/Correo entrantes", value: "79869559" },
    { name: "Aún no dice que no, seguimiento por 2 días", value: "81615327" },
    { name: "Leads interesados", value: "79717407" },
    { name: "Leads no interesados", value: "79719259" },
    { name: "Muy misio", value: "79753787" },
    { name: "Llamadas programadas", value: "79719263" },
    { name: "Meets programados", value: "79717419" },
    { name: "Cotización enviada (prospecto)", value: "79717411" },
    { name: "Me rendí", value: "81439775" },
    { name: "Prospecto a futuro", value: "81617899" },
    { name: "Perdieron interés (prospecto)", value: "79719267" },
    { name: "Trabaja en otra agencia / Freelance", value: "81615803" },
  ]

  const eventosCotizaciones = leadEvents.filter((event) => event.eventType === "Cambio estado cotización")
  const eventosLlamadas = leadEvents.filter((event) => event.eventType === "Llamada")
  const eventosMeets = leadEvents.filter((event) => event.eventType === "Google Meet")
  const eventosEntradas = leadEvents.filter((event) => event.eventType === "Entrada al sistema")

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal // Modal para eventos
        activeModal={newEventModal}
        onClose={() => {
          setNewEventModal(false)
          resetEventForm()
        }}
        title={`Crear nuevo evento para ${lead.leadName}`}
        className="max-w-3xl"
        centered
      >
        <form 
          className="max-h-[75vh] overflow-y-auto"
          onSubmit={(e) => handleSubmitNewEvent(e)}
        >
          <div className="flex flex-row gap-4">

            <div className="flex flex-col w-1/2">

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Título
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaRegNoteSticky />
                  </span>
                  <input
                    type="text"
                    placeholder="Título del evento"
                    value={newEventForm.title}
                    required
                    onChange={(e) => setNewEventForm((prev) => ({...prev, title: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Descripción
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <MdDescription  />
                  </span>
                  <textarea
                    type="text"
                    placeholder="Descripción del evento"
                    value={newEventForm.description}
                    rows={1}
                    required
                    onChange={(e) => setNewEventForm((prev) => ({...prev, description: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                  Fecha del evento
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaCalendar />
                  </span>
                  <input
                    type="datetime-local"
                    value={formatDateTimeForInputWithoutRound(newEventForm.scheduledDate)}
                    required
                    onChange={(e) => {
                      const isoDate = new Date(e.target.value).toISOString();
                      setNewEventForm((prev) => ({ ...prev, scheduledDate: isoDate }));
                    }}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Vendedor
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaUser />
                  </span>
                  <select
                    type="text"
                    value={newEventForm.seller}
                    required
                    onChange={(e) => setNewEventForm((prev) => ({...prev, seller: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  >
                    <option value={""}>Seleccionar</option>
                    {workers.map((worker) => (
                      <option value={worker.id}>{worker.name}</option>
                    ))}
                  </select>
                </div>
              </div>

            </div>

            <div className="flex flex-col w-1/2">

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Tipo de evento
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaTypo3 />
                  </span>
                  <select
                    type="text"
                    value={newEventForm.eventType}
                    required
                    onChange={(e) => setNewEventForm((prev) => ({...prev, eventType: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  >
                    <option value={""}>Seleccionar</option>
                    <option value={"Entrada al sistema"}>Entrada al sistema</option>
                    <option value={"Google Meet"}>Google Meet</option>
                  </select>
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                  Subtipo de evento
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaCheckCircle />
                  </span>
                  <select
                    type="text"
                    value={newEventForm.eventSubType}
                    required
                    onChange={(e) => setNewEventForm((prev) => ({...prev, eventSubType: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  >
                    {newEventForm.eventType === "Entrada al sistema" ? (
                        <>
                          <option value={""}>Seleccionar</option>
                          <option value={"Entrada al sistema"}>Entrada al sistema</option>
                        </>
                      ) : (
                        <>
                          <option value={""}>Seleccionar</option>
                          <option value={"Meet cancelado"}>Meet cancelado</option>
                          <option value={"Meet reagendado"}>Meet reagendado</option>
                          <option value={"Meet agendado"}>Meet agendado</option>
                          <option value={"Meet atendido"}>Meet atendido</option>
                        </>
                      )
                    }
                  </select>
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                  Link de la grabación del evento
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaLink />
                  </span>
                  <input
                    type="text"
                    placeholder="Link del evento"
                    value={newEventForm.eventLink}
                    onChange={(e) => setNewEventForm((prev) => ({...prev, eventLink: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

            </div>

          </div>

          <Button 
            variant="contained"
            type="submit"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              marginTop: "20px",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
           
              width: "100%",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
          >
            Guardar
          </Button>
        
        </form>
      </Modal>

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex items-center gap-4 py-4">
            <FaUser className="text-zinc-700 text-2xl" />
            <Link to={'/home/trackeoLeads'}>
              <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">
                Historial de leads
              </h2>
            </Link>
            <FaChevronRight className="text-orange-500 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">
              {lead.leadName} - <button onClick={() => CopyToClipBoard(lead.id)}>{lead.id}</button>
            </h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Vista:</span>
              <select
                value={viewMode}
                onChange={(e) => setViewMode(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="Tabla">Tabla</option>
                <option value="Calendario">Calendario</option>
              </select>
            </div>

            <div className="pl-4">
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "3px 24px",
                  whiteSpace: "nowrap",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                  
                }}
                onClick={() => setNewEventModal(true)}
              >
                Crear nuevo evento
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Datos y cotizaciones del lead */}
      {viewMode === "Tabla" && (
        <>
          <div className="flex flex-row bg-gray-100 mt-1 w-full gap-2 px-6">

            <div className="flex flex-col bg-gray-100 mt-1 mb-2 w-full ">
              <div className="w-full flex flex-row justify-between items-center">
                <span className="font-bold text-sm">Datos del lead</span>
                <div className="flex flex-row items-center justify-center gap-2">
                  <span className="font-bold text-xs">Eventos: {leadEvents.length}</span>
                  <IconButton
                    onClick={() => setOpenDetails(!openDetails)}
                    color="primary"
                    size="small"
                    aria-label="expand"
                    sx={{ transition: "0.3s", transform: openDetails ? "rotate(180deg)" : "rotate(0deg)" }}
                  >
                    <ExpandMoreIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </div>
              </div>
              
              {openDetails && (
                <div className="flex flex-row bg-gray-100 w-full mt-1 gap-2">

                  <div className="flex flex-col w-full justify-between items-center text-xs gap-1 w-1/2 px-2">
      
                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Nombre lead:</span>
                      <input
                        type="text"
                        value={lead.leadName}
                        onChange={(e) => HandleUpdateTextSelf("leadName", e.target.value, lead.id, "registroLeads", debounceUpdate, setLead)}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">País:</span>
                      <select 
                        value={lead.country}
                        onChange={(e) => HandleUpdateSelectSelf("country", e.target.value, lead.id, "registroLeads", setLead)}
                        className={`px-2 py-0 w-[50%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                      >
                        {countryNames.map((c, i) => (
                          <option key={i} value={c.name}>{c.name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">DNI:</span>
                      <input
                        type="text"
                        value={lead.dni}
                        onChange={(e) => HandleUpdateDNI({field: "dni", newValue: e.target.value, updateField: "leadName", targetID: lead.id, route: "registroLeads", debounceUpdate, userCountry: lead.country, setElement: setLead, element: lead})}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">RUC:</span>
                      <input
                        type="text"
                        value={lead.ruc}
                        onChange={(e) => HandleUpdateRUC({field: "ruc", newValue: e.target.value, updateField: "brandName", targetID: lead.id, route: "registroLeads", debounceUpdate, userCountry: lead.country, setElement: setLead, element: lead})}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>
      
                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Estado actual del usuario:</span>
                      <select 
                        value={lead.status}
                        onChange={(e) => HandleUpdateSelectSelf("status", e.target.value, lead.id, "registroLeads", setLead)}
                        className={`px-2 py-0 w-[50%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                      >
                        <option value="Lead" className="hover:cursor-pointer">Lead</option>
                        <option value="Prospecto" className="hover:cursor-pointer">Prospecto</option>
                        <option value="Cliente" className="hover:cursor-pointer">Cliente</option>
                      </select>
                    </div>
      
                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Vende:</span>
                      <input
                        type="text"
                        value={lead.sells}
                        onChange={(e) => HandleUpdateTextSelf("sells", e.target.value, lead.id, "registroLeads", debounceUpdate, setLead)}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>
      
                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Ticket:</span>
                      <input
                        type="text"
                        value={lead.ticketProduct}
                        onChange={(e) => HandleUpdateTextSelf("ticketProduct", e.target.value, lead.id, "registroLeads", debounceUpdate, setLead)}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>
      
                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Presupuesto:</span>
                      <input
                        type="text"
                        value={lead.budget}
                        onChange={(e) => HandleUpdateTextSelf("budget", e.target.value, lead.id, "registroLeads", debounceUpdate, setLead)}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>
                        
                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Nombre de marca:</span>
                      <input
                        type="text"
                        value={lead.brandName}
                        onChange={(e) => HandleUpdateTextSelf("brandName", e.target.value, lead.id, "registroLeads", debounceUpdate, setLead)}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>
      
                  </div>
      
                  <div className="flex flex-col w-full justify-between items-center text-xs gap-1 w-1/2 px-2">

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Responsable:</span>
                      <span>{lead.responsible?.name}</span>
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Etapa:</span>
                      <select 
                        value={lead.stage}
                        onChange={(e) => HandleUpdateSelectSelf("stage", e.target.value, lead.id, "registroLeads", setLead)}
                        className={`px-2 py-0 w-[50%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                      >
                        {stages.map((s) => (
                          <option value={s.value}>{s.name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Puesto:</span>
                      <input
                        type="text"
                        value={lead.position}
                        onChange={(e) => HandleUpdateTextSelf("position", e.target.value, lead.id, "registroLeads", debounceUpdate, setLead)}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Teléfono:</span>
                      <input
                        type="text"
                        value={lead.phone}
                        onChange={(e) => HandleUpdateTextSelf("phone", e.target.value, lead.id, "registroLeads", debounceUpdate, setLead)}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Email:</span>
                      <input
                        type="text"
                        value={lead.email}
                        onChange={(e) => HandleUpdateTextSelf("email", e.target.value, lead.id, "registroLeads", debounceUpdate, setLead)}
                        className={`px-2 w-[50%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs`}
                      />
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Origen del lead:</span>
                      <select 
                        value={lead.leadOrigin}
                        onChange={(e) => HandleUpdateSelectSelf("leadOrigin", e.target.value, lead.id, "registroLeads", setLead)}
                        className={`px-2 py-0 w-[50%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                      >
                        <option value={"Sin definir"}>Sin definir</option>
                        <option value={"Recomendación"}>Recomendación</option>

                        <option value={"Orgánico"}>Orgánico</option>
                        <option value={"Web orgánico"}>Web orgánico</option>

                        <option value={"Facebook Ads"}>Facebook Ads</option>
                        <option value={"Google Ads"}>Google Ads</option>
                        <option value={"Linkedin Ads"}>Linkedin Ads</option>
                        <option value={"Tiktok Ads"}>Tiktok Ads</option>
                        <option value={"Youtube Ads"}>Youtube Ads</option>

                        <option value={"Facebook"}>Facebook</option>
                        <option value={"Google"}>Google</option>
                        <option value={"Linkedin"}>Linkedin</option>
                        <option value={"Tiktok"}>Tiktok</option>
                        <option value={"Youtube"}>Youtube</option>
                      </select>
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Origen de entrada:</span>
                      <select 
                        value={lead.entryOrigin}
                        onChange={(e) => HandleUpdateSelectSelf("entryOrigin", e.target.value, lead.id, "registroLeads", setLead)}
                        className={`px-2 py-0 w-[50%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                      >
                        <option value={null}>Seleccionar</option>
                        <option value={"Kommo"}>Kommo</option>
                        <option value={"WhatsApp"}>WhatsApp</option>
                        <option value={"Llamada"}>Llamada</option>
                      </select>
                    </div>

                    <div className="flex flex-row w-full justify-between items-center">
                      <span className="font-semibold">Origen de marca:</span>
                      <select 
                        value={lead.brandOrigin}
                        onChange={(e) => HandleUpdateSelectSelf("brandOrigin", e.target.value, lead.id, "registroLeads", setLead)}
                        className={`px-2 py-0 w-[50%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                      >
                        <option value={"Sin definir"}>Sin definir</option>
                        <option value={"Mundo Digital"}>Mundo Digital</option>
                        <option value={"Allsavfe"}>Allsavfe</option>
                        <option value={"W3P"}>W3P</option>
                        <option value={"Monstruo Creativo"}>Monstruo Creativo</option>
                        <option value={"SEOluciones"}>SEOluciones</option>
                        <option value={"Nodo"}>Nodo</option>
                        <option value={"Aura BTL"}>Aura BTL</option>
                        <option value={"Conviertelo"}>Conviertelo</option>
                        <option value={"Lucuma"}>Lucuma</option>
                      </select>
                    </div>
                  </div>
      
                </div>
              )}

            </div>
    
          </div>

          <div className="flex flex-row bg-gray-100 mt-1 w-full gap-2 px-6">

            <div className="flex flex-col bg-gray-100 mt-1 mb-2 w-full ">

              <div className="w-full flex flex-row justify-between items-center">
                <span className="font-bold text-sm">Cotizaciones del lead</span>
                <div className="flex flex-row items-center justify-center gap-2">
                  <span className="font-bold text-xs">Cotizaciones: {quotes.length}</span>
                  <IconButton
                    onClick={() => setOpenQuotes(!openQuotes)}
                    color="primary"
                    size="small"
                    aria-label="expand"
                    sx={{ transition: "0.3s", transform: openQuotes ? "rotate(180deg)" : "rotate(0deg)" }}
                  >
                    <ExpandMoreIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </div>
              </div>
              
              {openQuotes && (
                <div className="flex flex-row bg-gray-100 w-full mt-1 gap-2 overflow-y-auto">
                  {quotes && quotes.length === 0 ? (
                      <div className="flex w-full h-[50px] items-center justify-center border border-gray-300 rounded-md">
                        <div className="flex flex-row gap-2 items-center justify-center text-[10px] text-gray-400">
                          Este lead no tiene cotizaciones
                          <FaInfoCircle />
                        </div>
                      </div>
                    ) : (
                      quotes.map((q) => (
                        <div className="w-[200px] bg-white hover:bg-gray-50 transition-all duration-100 shadow-md hover:shadow-lg border border-gray-300 rounded-md p-2">
                          <div className="flex flex-col gap-0.3 items-center justify-center">
                            
                            <div className="flex w-full flex-row justify-between items-center">
                              <span className="font-semibold text-[10px]">ID</span>
                              <button
                                onClick={() => CopyToClipBoard(q.id)}
                                className="flex flex-row gap-1 items-center justify-center hover:underline hover:cursor-pointer transition-all duration-100"
                              >
                                <FaLink className="text-[10px] text-blue-500"/>
                                <span className="text-[10px]">Copiar ID</span>
                              </button>
                            </div>

                            <div className="flex w-full flex-row justify-between items-center">
                              <span className="font-semibold text-[10px]">Estado</span>
                              <span className={`text-[10px] ${q?.estado === "Exito" ? "text-green-500" : 
                                  q?.estado === "En espera" ? "text-yellow-300" :
                                  q?.estado === "Perdido" ? "text-red-500" :
                                  q?.estado === "Anulada" ? "text-black" : ""
                                }`}
                              >
                                {q.estado}
                              </span>
                            </div>
                            <div className="flex w-full flex-row justify-between items-center">
                              <span className="font-semibold text-[10px]">Vendedor</span>
                              <span className="text-[10px]">{q.cotizador?.name}</span>
                            </div>
                            <div className="flex w-full flex-row justify-between items-center">
                              <span className="font-semibold text-[10px]">Precio total</span>
                              <span className="text-[10px]">{q.precioTotal}</span>
                            </div>
                            <div className="flex w-full flex-row justify-between items-center">
                              <span className="font-semibold text-[10px]">Moneda</span>
                              <span className="text-[10px]">{q.moneda}</span>
                            </div>
                            <div className="flex w-full flex-row justify-between items-center">
                              <span className="font-semibold text-[10px]">Creado</span>
                              <span className="text-[10px]">{new Date(q.createdAt).toLocaleDateString()}</span>
                            </div>
                            <div className="flex w-full flex-row justify-between items-center">
                              <span className="font-semibold text-[10px]">Fecha límite</span>
                              <span className="text-[10px]">{new Date(q.fechaCotizacionLimite).toLocaleDateString()}</span>
                            </div>


                            {/* <div className="flex w-full flex-row justify-between items-center">
                              <span className="font-semibold text-[10px]">Detalle</span>
                              <button className="flex flex-row gap-1 items-center justify-center hover:underline hover:cursor-pointer transition-all duration-100">
                                <FaExternalLinkAlt className="text-[10px] text-blue-500"/>
                                <span className="text-[10px]">Ver</span>
                              </button>
                            </div> */}
                            
                          </div>
                        </div>
                      ))
                    )
                  }
                </div>
              )}

            </div>

          </div>

          <div className="flex flex-row bg-gray-100 mt-1 w-full gap-2 px-6">

            <div className="flex flex-col bg-gray-100 mt-1 mb-2 w-full ">

              <div className="w-full flex flex-row justify-between items-center">
                <span className="font-bold text-sm">Notas del lead</span>
                <div className="flex flex-row items-center justify-center gap-2">
                  <span className="font-bold text-xs">Notas: {notes.length}</span>
                  <IconButton
                    onClick={() => setOpenNotes(!openNotes)}
                    color="primary"
                    size="small"
                    aria-label="expand"
                    sx={{ transition: "0.3s", transform: openNotes ? "rotate(180deg)" : "rotate(0deg)" }}
                  >
                    <ExpandMoreIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </div>
              </div>

              {openNotes && (
                <div className="flex flex-col gap-2 w-full">
                  <div className="flex flex-row overflow-x-auto bg-gray-100 w-full mt-1 gap-2 overflow-y-auto">
                    {notes && notes.length === 0 ? (
                      <div className="flex w-full h-[50px] items-center justify-center border border-gray-300 rounded-md">
                        <div className="flex flex-row gap-2 items-center justify-center text-[10px] text-gray-400">
                          Este lead no tiene notas
                          <FaInfoCircle />
                        </div>
                      </div>
                    ) : (
                      notes.map((n, i) => (
                        <div key={i} className="min-w-[300px] max-w-[300px] overflow-y-auto h-[100px] text-xs px-2 mb-1 py-1 flex flex-col bg-white shadow rounded">
                          <span className="flex flex-row gap-2 items-center mb-1">
                            <FaRegClock className="text-xs text-orange-500"/>
                            <span className="truncate">{FormatTimeStamp(n.created_at)}</span>
                          </span>
                          <span>{n.params.text}</span>
                        </div>
                      ))
                    )}
                  </div>
                  <div className="p-1">
                    <div className="flex flex-row gap-1 items-center justify-center">
                      <input 
                        type="text"
                        placeholder="Nueva nota..."
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                        className="text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10 w-full"
                      />
                      <Button
                        variant="contained"
                        onClick={postNotes}
                        disabled={postNoteLoader}
                        sx={{
                          padding: "6px",
                          backgroundColor: "#ff6400",
                          width: "150px",
                          textTransform: "none",
                          borderRadius: "8px",
                          '&:hover': { backgroundColor: "#bb4a03" },
                        }}
                      >
                        {postNoteLoader ? <FaSpinner className="animate-spin text-white" /> : <SendSharp sx={{fontSize: 16}}/>}
                      </Button>
                    </div>
                  </div>
                </div>
              )}

            </div>

          </div>

        </>
      )}

      {/* Agregar una sección para mostrar los valores globales */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10 px-8 py-1">
        <div className="flex flex-row items-center justify-between w-full gap-4">
          <span className="text-xs text-gray-700">
            Llamadas totales: <span className="text-gray-700 font-bold"> {eventosLlamadas.length} / {((eventosLlamadas.length / leadEvents.length) * 100).toFixed(1)}% </span> 
          </span>
          <span className="text-xs text-gray-700">
            Meets totales: <span className="text-gray-700 font-bold"> {eventosMeets.length} / {((eventosMeets.length / leadEvents.length) * 100).toFixed(1)}% </span>
          </span>
          <span className="text-xs text-gray-700">
            Total de entradas al sistema: <span className="text-gray-700 font-bold">{eventosEntradas.length} / {((eventosEntradas.length / leadEvents.length) * 100).toFixed(1)}% </span>
          </span>
          <span className="text-xs text-gray-700">
            Cotizaciones totales: <span className="text-gray-700 font-bold"> {eventosCotizaciones.length} / {((eventosCotizaciones.length / leadEvents.length) * 100).toFixed(1)}% </span>
          </span>
        </div>
      </div>

      {/* FilterBar */}
      <div className="flex bg-gray-100 mt-1 mb-1 w-full gap-10">
       <div className="flex flex-row w-full items-center justify-between overflow-x-auto px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row gap-4 items-center justify-center">
                
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Vendedor:</span>
              <select
                value={seller}
                onChange={(e) => setSeller(e.target.value)}
                className="w-[150px] text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value="">Seleccionar</option>
                {workers.map((worker) => (
                  <option value={worker.id}>{worker.name}</option>
                ))}
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Tipo evento:</span>
              <select
                value={eventType}
                onChange={(e) => setEventType(e.target.value)}
                className="w-[200px] text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value={""}>Seleccionar</option>
                <option value={"Entrada al sistema"}>Entrada al sistema</option>
                <option value={"Llamada"}>Llamada</option>
                <option value={"Google Meet"}>Google Meet</option>
                <option value={"Cambio estado cotización"}>Cambio estado cotización</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Subtipo del evento:</span>
              <select
                value={eventSubType}
                onChange={(e) => setEventSubType(e.target.value)}
                className="w-[250px] text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value={""}>Seleccionar</option>

                {eventType === "Entrada al sistema" && (
                  <>
                    <option value={"Entrada al sistema"}>Entrada al sistema</option>
                  </>
                )}
         
                {eventType === "Llamada" && (
                  <>
                    <option value={"Llamada perdida"}>Llamada perdida</option>
                    <option value={"Llamada corta"}>Llamada corta</option>
                    <option value={"Llamada fria"}>Llamada fria</option>
                    <option value={"Llamada atendida"}>Llamada atendida</option>
                  </>
                )}

                {eventType === "Google Meet" && (
                  <>
                    <option value={"Meet cancelado"}>Meet cancelado</option>
                    <option value={"Meet reagendado"}>Meet reagendado</option>
                    <option value={"Meet agendado"}>Meet agendado</option>
                    <option value={"Meet atendido"}>Meet atendido</option>
                  </>
                )}

                {eventType === "Cambio estado cotización" && (
                  <>
                    <option value={"Exito"}>Exito</option>
                    <option value={"Evaluando opciones"}>Evaluando opciones</option>
                    <option value={"Para el futuro"}>Para el futuro</option>
                    <option value={"Frio"}>Frio</option>
                    <option value={"Por confirmar depósito"}>Por confirmar depósito</option>
                    <option value={"Curioso"}>Curioso</option>
                    <option value={"No responde"}>No responde</option>
                    <option value={"El servicio le parece caro"}>El servicio le parece caro</option>
                    <option value={"Decidió trabajar con otra agencia"}>Decidió trabajar con otra agencia</option>
                    <option value={"Decidió trabajar con un freelancer"}>Decidió trabajar con un freelancer</option>
                    <option value={"No esta en mi ciudad"}>No esta en mi ciudad</option>
                    <option value={"Competencia o sospechoso"}>Competencia o sospechoso</option>
                    <option value={"Lead con poco presupuesto"}>Lead con poco presupuesto</option>
                  </>
                )}

              </select>

              <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
                <span className="truncate">Servicio de interés:</span>
                <select
                  value={serviceInterest}
                  onChange={(e) => setServiceInterest(e.target.value)}
                  className="w-[180px] text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
                >
                  <option value={""}>Seleccionar</option>
                  {services.map((s) => (
                    <option value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        <div className="flex flex-row w-full">
          {loadingStatus ? (
          <LoadingScreen />
            ) : (
              leadEvents.length === 0 ? (
                <NoDataScreen />
              ) : (
                viewMode === "Tabla" ? (
                  <table className="w-full">
                    <thead className="bg-white sticky top-0">
                      <tr className="text-gray-700 text-center text-[10px] font-bold">
                        {user.area.toUpperCase() === "ADMINISTRACION" && (
                          <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                            <div className="text-white w-full flex items-center justify-center">
                              <FaTrash />
                            </div>
                          </th>
                        )}
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Fecha y hora creación
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Nombre Lead
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Título
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Descripción evento
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Vendedor
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Estado del usuario del evento
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Tipo evento
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Subtipo del evento
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          <span>Fecha y hora de agendamiento</span> {"\n"} <span className="truncate">(Google Meet)</span>
                        </th>
                        {/* <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Fecha de reagenda
                        </th> */}
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Link evento
                        </th>
                        <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Cotizacion anexada
                        </th>
                        <th className="px-2 py-3 z-20 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Servicio interés
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {leadEvents.map((e) => (
                        <ItemRowEvent
                          event={e}
                          setEvents={setLeadEvents}
                          workers={workers}
                          services={services}
                          user={user}
                        />
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="flex w-full gap-2">
                    <div className="px-2 flex-1">
                      <FullCalendar
                        events={leadEventsForTable}
                        eventOrder={"order,start,-duration,title"}
                        height="75vh"
                        eventClick={(info) => {
                          CopyToClipBoard(info.event.extendedProps.phone, "Número de teléfono copiado al portapapeles");
                        }}
                        datesSet={(e) => {
                          const viewStartDate = e.view.currentStart;
                          const viewEndDate = e.view.currentEnd;
                      
                          // Actualiza el rango con las fechas de la vista actual (mes, año, semana, etc.)
                          setRangeDates({
                            start: viewStartDate.toISOString().split('T')[0], // Fecha de inicio de la vista
                            end: viewEndDate.toISOString().split('T')[0],     // Fecha de fin de la vista
                          });
                        }}
                        plugins={[
                          dayGridPlugin,
                          timeGridPlugin,
                          interactionPlugin,
                          listPlugin,
                          multiMonthPlugin,
                        ]}
                        moreLinkText={"Ver todos"}
                        locale={"es"}
                        headerToolbar={{
                          start: isMobile ? "prev,next" : "title",
                          center:
                            !isMobile &&
                            "multiMonthYear,dayGridMonth",
                          end: isMobile
                            ? "multiMonthYear,dayGridMonth"
                            : "prev,next",
                        }}
                        buttonText={{
                          today: "Hoy",
                          month: "Mes",
                          year: "Año",
                          week: "Semana",
                          day: "Día",
                          listMonth: "Agenda del mes",
                          listDay: "Agenda hoy",
                          timeGrid: "Semana",
                        }}
                        footerToolbar={{
                          start: isMobile ? "listMonth" : "listMonth listDay",
                          center: isMobile ? "" : "today",
                        }}
                        views={{
                          timeGridFourDay: {
                            type: "timeGrid",
                            duration: { days: 4 },
                            buttonText: "Semana",
                          },
                          timeGridWeek: {
                            duration: { days: isMobile ? 4 : 7 },
                            buttonText: "Semana",
                          },
                        }}
                        initialView={"dayGridMonth"}
                        moreLinkHint={true}
                        defaultAllDay
                        dayMaxEvents={false}
                        eventContent={function (arg) {

                          let containerEl = document.createElement("div");

                          containerEl.classList = `event-container cursor-pointer transition-all duration-100 border border-gray-300 rounded-md text-black ${arg.event.extendedProps.color}`;
                        
                          let contentEl = document.createElement("p");
                          contentEl.classList = "event-content overflow-hidden";
                          contentEl.innerHTML = `${arg.event.title}`;
                        
                          containerEl.appendChild(contentEl);
                          return { domNodes: [containerEl] };
                        }}
                        eventDidMount={(info) => {
                          Tippy(info.el, {
                            content: `${info.event.extendedProps.description}`,
                            placement: 'top',
                            theme: 'dark',
                            animation: 'scale'
                          });
                        }}
                        initialEvents={[]}
                      />
                    </div>
                  </div>
                )
              )
            )
          }
        </div>
      </div>
      
    </div>
  )
}

export default EventosLeads